
import { defineComponent } from 'vue'
import DashedLine from '@/components/DashedLine.vue'

export default defineComponent({
	name: 'EventTextSection',
	components: { DashedLine },

	props: {
		// Always string. Object type needs for TS
		icon: {
			type: [String, Object],
			required: true
		},
		text: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			required: true
		},
		iconClass: {
			type: String,
			default: ''
		}
	},

	setup(props) {
		return props
	}
})
